<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div class="global-header-section">
                <div class="svg-icon-panel"><img src="../../../../../assets/emailtitle.svg" class="mr-1" />SMTP Settings</div>
            </div>
            <div>
                <div *ngIf="smtpEditMode===0 && !cancelEditSmtp && !warningStr" class="alert-panel">Select a user to edit SMTP settings.</div>
                <div *ngIf="smtpEditMode===0 && cancelEditSmtp && !warningStr" class="apply-credit-subHeader">Select a user to edit SMTP settings..</div>
                <div *ngIf="smtpEditMode===1 && !warningStr" class="apply-credit-subHeader">Select a user to edit SMTP settings..</div>
                <div *ngIf="smtpEditMode===2 && !warningStr" class="apply-credit-subHeader">Send a test email by clicking Test..</div>
                <div class="warning-alert" *ngIf="warningStr"><span [innerHTML]="warningStr"></span></div>
            </div>
            <form [formGroup]="smtpForm" (ngSubmit)="smtpFormSubmit()">
                <div *ngIf="smtpEditMode <=1" class="smtp-row ">
                    <div class="p-3">
                        <select formControlName="selectedUserId" class="ddStandard-tagsettings mt-10" (change)="loadSmtpSettings()">
                            <option value="-1">Select </option>
                            <option *ngFor="let arrTagSettings of smtpUserList" [value]="arrTagSettings?.id">{{arrTagSettings?.text}}</option>
                        </select>
                    </div>
                </div>
                <div *ngIf="smtpEditMode >= 1">
                    <div class="wraper-body-panel">
                        <div class="wraper-body-left">
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>User</span></div>
                                <div class="cards-colunm-right">
                                    <span>{{getUserName(selectedUser)}}</span>
                                </div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>SMTP Server</span></div>
                                <div class="cards-colunm-right"><input type="text" [readonly]="smtpEditMode === 2" class="form-control" id="sMTPServer" name="sMTPServer" formControlName="sMTPServer" /></div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>Username</span></div>
                                <div class="cards-colunm-right"><input type="text" [readonly]="smtpEditMode === 2" class="form-control" id="username" name="username" formControlName="username" /></div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>Password</span></div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 1"><input type="text" [readonly]="smtpEditMode === 2" class="form-control" id="password" name="password" formControlName="password" /></div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 2">******</div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>SMTP Port</span></div>
                                <div class="cards-colunm-right"><input type="text" [readonly]="smtpEditMode === 2" class="form-control" id="sMTPPort" name="sMTPPort" formControlName="sMTPPort" /></div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>SMTP Authentication</span></div>
                                <div class="cards-colunm-right">
                                    <select class="form-control" id="sMTPAuthenticate" name="sMTPAuthenticate" formControlName="sMTPAuthenticate">
                                        <option [value]="1">Basic</option>
                                    </select>
                                </div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>Use SSL</span></div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 1"><input type="checkbox" class="checkbox" id="useSSL" formControlName="useSSL" /></div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 2">
                                    <span class="text-danger">{{this.smtpFormData.useSSL ? 'In Use' : 'Not In Use'}}</span>                                    
                                </div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"><span>Activate</span></div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 1">
                                    <input type="checkbox" class="checkbox" id="enableCLPSMTP" formControlName="enableCLPSMTP" />
                                    <span>check this box to activate these smtp settings for this user.</span>
                                </div>
                                <div class="cards-colunm-right" *ngIf="smtpEditMode === 2">
                                    <span class="text-danger">{{this.smtpFormData.enableCLPSMTP ? 'Active' : 'Not Active'}}</span>
                                </div>
                            </div>
                            <div class="cards-body-section" *ngIf="smtpEditMode === 2">
                                <div class="cards-colunm-left min-width150"></div>
                                <div class="cards-colunm-right">
                                    <input type="text" class="form-control" style="width:auto" id="testTo" name="testTo" formControlName="testTo" />
                                </div>
                            </div>
                            <div class="cards-body-section">
                                <div class="cards-colunm-left min-width150"></div>
                                <div class="cards-colunm-right">
                                    <div *ngIf="smtpEditMode === 1">
                                        <button type="button" class="btn btn-primary" id="primarySaveWeb" [hidden]="roleFeaturePermissions?.edit == false || roleFeaturePermissions?.create == false" (click)="onNext()">Next</button>
                                    </div>
                                    <div *ngIf="smtpEditMode === 2">
                                        <button class="btn btn-primary" *ngIf="!sendTestSuccess" id="primarySaveWeb" type="button" (click)="sendTestEmail()">Test</button>
                                        <button class="btn btn-primary" *ngIf="sendTestSuccess" id="primarySaveWeb" type="button" (click)="updateSmtpForm()">Confirm</button>
                                        <button class="btn btn-cancel" id="primarySaveWeb" type="button" (click)="cancelSmtp();">Cancel</button>
                                    </div>
                                    <div>
                                        <button class="btn btn-danger" type="button" (click)="onDeleteSMTPSetting()" *ngIf="selectedUser > 0 && this.smtpFormData?.cLPSMTPID > 0"><i class="fa fa-trash-alt mr-2"></i>Clear Settings</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div *ngIf="clpsmtpList?.length" class="global-body-section">
                <div class="smtp-setting-grid">
                    <table mat-table [dataSource]="clpSmtpListSource" matSort class="mat-elevation-z8">
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }}</th>
                            <td mat-cell *matCellDef="let dataItem" [ngSwitch]="column.field">
                                <mat-checkbox *ngSwitchCase="'enableCLPSMTP'" [checked]="dataItem.enableCLPSMTP" disabled> </mat-checkbox>
                                <mat-checkbox *ngSwitchCase="'useSSL'" [checked]="dataItem.useSSL" disabled> </mat-checkbox>
                                <span *ngSwitchDefault> {{ dataItem[column.field] }} </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="clpSmtpListDisplayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: clpSmtpListDisplayColumns;"></tr>
                    </table>
                    <mat-paginator *ngIf="clpsmtpList?.length > 0" [length]="clpsmtpList.length" [pageSizeOptions]="[10, 50, 100, 200]"> </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="loader-body" *ngIf="showSpinner ">
    <div class="lds-ripple"><div></div><div></div></div>
</div>

